export default {"src":"/_next/static/media/powered.2e9e1a72.svg","height":57,"width":52};